module.exports = __webpack_public_path__ + "media/images/export-failed-result-77b4b3449eda093dfe6a62b9fac4c351.svg";